import { useMemo } from 'react'
import { z } from 'zod'
import type { Course } from '@mc/api'
import { useExperimentVariables } from '@mc/experiments-react'
import { CM_INNOVATIVE_SWING_FLAG_NAME } from '../constants'

const CMInnovativeSwingDataSchema = z.object({
  copy: z.record(z.string()).optional(), // It's optional because in control & variant_2 we do not need it.
  classes: z.array(z.string()),
})

export type CMInnovativeSwingDataSchema = z.infer<
  typeof CMInnovativeSwingDataSchema
>

const useCMInnovativeSwingData = () => {
  const variables = useExperimentVariables(CM_INNOVATIVE_SWING_FLAG_NAME)

  const parsedData = useMemo(() => {
    const parsed = CMInnovativeSwingDataSchema.safeParse(variables)
    return parsed.success ? parsed.data : null
  }, [variables])

  return parsedData
}

export const useGetCMInnovativeSwingCopy = (course: Course) => {
  const data = useCMInnovativeSwingData()

  if (!data) return course.headline

  const { copy } = data

  // It should not happen that the course does not have a copy but just in case i added headline
  return copy?.[course.slug] ?? course.headline
}

export const useGetCmInnovativeSwingClasses = () => {
  const data = useCMInnovativeSwingData()

  if (!data) return null

  const { classes } = data

  return classes
}
